import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  IconButton
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Call as CallIcon
} from '@mui/icons-material';

const SalonQuickInfo = ({ salon, isMobile = false }) => {
  const handlePhoneCall = () => {
    window.location.href = `tel:${salon.phone}`;
  };

  const handleEmail = () => {
    window.location.href = `mailto:${salon.email || ''}`;
  };

  if (isMobile) {
    return (
      <Card sx={{ mt: -4, position: 'relative', zIndex: 1, borderRadius: 3, boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Chip
              onClick={() => {}}
              label={salon.category} 
              sx={{ 
                backgroundColor: '#F5F5DC', 
                color: '#000000', 
                fontWeight: 500,
                fontSize: '0.75rem'
              }}
            />
          </Box>

          {/* Contact Info */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <LocationIcon sx={{ mr: 1.5, color: '#6B7280', fontSize: '1.25rem' }} />
            <Typography variant="body2" sx={{ color: '#6B7280', flex: 1 }}>
              {salon.address ? `${salon.address}, ` : ''}{salon.city}, {salon.region}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PhoneIcon sx={{ mr: 1.5, color: '#6B7280', fontSize: '1.25rem' }} />
              <Typography variant="body2" sx={{ color: '#6B7280' }}>
                {salon.phone}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton 
                size="small" 
                onClick={handlePhoneCall}
                sx={{ 
                  backgroundColor: '#F5F5DC', 
                  color: '#000000',
                  '&:hover': { backgroundColor: '#E8E8D0' }
                }}
              >
                <CallIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={handleEmail}
                sx={{
                  backgroundColor: '#6B7280',
                  color: '#FFFFFF',
                  '&:hover': { backgroundColor: '#4B5563' }
                }}
              >
                <EmailIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {salon.description && (
            <Typography variant="body2" sx={{ color: '#6B7280', mt: 2, lineHeight: 1.5 }}>
              {salon.description}
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  }

  // Desktop version
  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h3" component="h1" gutterBottom>
          {salon.salonName}
        </Typography>
        <Chip 
          onClick={() => {}}
          label={salon.category} 
          sx={{ backgroundColor: '#f5f5dc', color: 'black', mb: 2 }}
        />
      </Box>

      <Box display="flex" alignItems="center" mb={1}>
        <LocationIcon sx={{ mr: 1, color: 'text.secondary' }} />
        <Typography variant="body1">
          {salon.address ? `${salon.address}, ` : ''}{salon.city}, {salon.region}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" mb={2}>
        <PhoneIcon sx={{ mr: 1, color: 'text.secondary' }} />
        <Typography variant="body1">
          {salon.phone}
        </Typography>
      </Box>

      {salon.description && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {salon.description}
        </Typography>
      )}
    </Box>
  );
};

export default SalonQuickInfo;